
import manualButton from '../manual-button';
import searchMultiplyDate from '@/components/search-multiply-date';
import dateFormat from 'vux/src/tools/date/format.js'


export default {
name: "expires-query-p",
components: {
manualButton,
searchMultiplyDate
},
data() {
return {
show: true,
typeList:[{name: '全部', code: ''}],
supcrossstaList: [
{name: '全部', code: '', selected: true},
{name: '注册', code: '注册'},
{name: '潜在', code: '潜在'},
{name: '合作中', code: '合作中'},
{name: '停用', code: '停用'},
{name: '黑名单', code: '黑名单'},
],
checkedDtoList:[],
time1:null,
time2:null,
time3:null,
time4:null
}
},
methods: {
closeReset(){},
reload(){
this.checkedDtoList=[];
this.time1 = null;
this.time2 = null;
this.time3 = null;
this.time4 = null;
this.show = false;
this.$nextTick(()=>{
this.show = true;
})
},
getTypeList(){
this.$get('api/qual-detail/all').then(data=>{
data.forEach(val=>{
let item = {
name: val.name,
code: val.code,
};
this.typeList.push(item)
})
})

},
checkerChange(value,name,chinese,option="IN"){
this.checkedDtoList=this.checkedDtoList.filter(val=>val.name!=name);
if(value){
if(option === "IN"){
this.checkedDtoList.push({name,code:[value],ch:chinese,option:option});
}else if(option === "BTD") {
this.checkedDtoList.push({name,code:value,ch:chinese,option:option});
}
}
},
changeDate(str){
if(str === 'validFrom'){
this.checkerChange([this.time1,this.time2],"validFrom",'生效日期',"BTD");
}else{
this.checkerChange([this.time3,this.time4],"validFrom",'失效日期',"BTD");
}
}
},
created() {
this.getTypeList()
}
}



// WEBPACK FOOTER //
// ./src/components/manual-search/expires-query-p.vue